






















































import { Vue, Component } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { required, email } from 'vuelidate/lib/validators';
import { routeTo } from '@/api/reactor/reactions';

@Component({
  validations: {
    form: {
      email: {
          required,
          email
      },
      password: {
          required
      },
    },
  },
  reactions: {
    '$auth/setNeedsPassword': routeTo('changeTempPassword'),
  }
})
export default class Login extends Vue {
  working: boolean = false;
  form: any = {
    email: '',
    password: ''
  };
  errorSnack: boolean = false;
  snackMessage: string = "";

  get nameErrors () {
    const errors: any[] = [];
    if (this.$v && this.$v.form && this.$v.form.email) {
      if (!this.$v.form.email.$dirty) return errors;
      !this.$v.form.email.required && errors.push('Email is required.');
      !this.$v.form.email.email && errors.push('Need a valid email.');
    }
    return errors
  }

  get passwordErrors () {
    const errors: any[] = [];
    if (this.$v && this.$v.form && this.$v.form.password) {
      if (!this.$v.form.password.$dirty) return errors;
      !this.$v.form.password.required && errors.push('Password is required.');
    }
    return errors
  }

  async authenticate () {
      try {
        this.working = true;
        await this.$store.dispatch('$auth/signIn', this.form);
      } catch (e) {
        console.log('login exception', e);
        if (e.code && e.code == "NotAuthorizedException") {
          this.snackMessage = e.message;
        } else {
          this.snackMessage = "Unable to sign in";
        }
        this.errorSnack = true;
      }
      this.working = false;
  }
}
